import http from '@/services/rest/rest.service';
import { ICompany } from '@/entities/offices/company.interface';
import { IAgentAccountModel } from '@/entities/agents/agent-account-model.interface';
import { AgentQuery } from '@/entities';

export default {
    list(onlyAvailable: boolean = true): Promise<ICompany[]> {
        return http.get(`companies?onlyAvailable=${onlyAvailable}`);
    },

    listAgents(
        companyId: number = null,
        agentsQuery: AgentQuery = AgentQuery.All
    ): Promise<IAgentAccountModel[]> {
        if (companyId) {
            return http.get(
                `companies/agents?companyId=${companyId}&agentsQuery=${agentsQuery}`
            );
        } else {
            return http.get(`companies/agents?agentsQuery=${agentsQuery}`);
        }
    }
};
